"use client";

import { useEffect, useState } from "react";
import ENDPOINTS from "@/lib/endpoints";
import { request } from "@/lib/helpers";

export default function useCareer(categoryId = 0) {
    const [jobs, setJobs] = useState([]);
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchJobs = async () => {
            setLoading(true);
            try {
                let url;
                if (categoryId === 0) {
                    url = `${ENDPOINTS.JOBS}`;
                } else {
                    url = `${ENDPOINTS.JOBS}/${categoryId}`;
                }

                const { data } = await request.get(url);

                setJobs(data.data.jobs?.data || []);
                setCategories(data.data.categories || []);
            } catch (error) {
                console.error("Failed to fetch jobs", error);
            } finally {
                setLoading(false);
            }
        };

        fetchJobs();
    }, [categoryId]);

    return { jobs, categories, loading };
}
